const statusConst = {
  UNPAID: 1,
  PARTIAL: 2,
  PAID: 3,
  CUSTOMER: 3,
  VOID: 113,
  APPROVAL_DRAFT: 111,
  APPROVAL_REJECT: 112,
}

export const approvalProgressStatus = {
  APPROVED: 3,
  REJECTED: 4,
}

const statusColors = [
  { id: 1, name: 'Unpaid', color: '#CF2A28' },
  { id: 2, name: 'Partial', color: '#EB9234' },
  { id: 3, name: 'Paid', color: '#11A428' },
  { id: 113, name: 'Void', color: '#ADC2D0' },
  { id: statusConst.APPROVAL_DRAFT, name: 'Approval Draft', color: '#13A4FF' },
  { id: statusConst.APPROVAL_REJECT, name: 'Reject', color: '#CF2A28' },
]

export { statusConst, statusColors }
